import { Temperamento } from "../../../services/mascotasServicios";
import {
  EstadoAnimo,
  NuevoReporteDiario,
  ReporteDiario,
} from "../../../services/reporteDiarioServicios";

export type Model = {
  desayuno?: boolean;
  almorzo?: boolean;
  ceno?: boolean;
  observacionesAlimenticias?: string;
  observacionesMedicas?: string;
  tomoMedicamentos: boolean;
  temperamento: Temperamento;
  observacionesSocializacion?: string;
  estadoAnimo: EstadoAnimo;
  novedades?: string;
  fotoNovedades?: File;
  fotoNovedadesUrl?: string;
  fotoGeneral?: File;
  fotoGeneralUrl?: string;
  videoNovedades?: File;
  videoNovedadesUrl?: string;
  aplicaDesayuno: boolean;
  aplicaAlmuerzo: boolean;
  aplicaCena: boolean;
  aplicaMedicamentos: boolean;
};

export const defaultValues: Model = {
  desayuno: true,
  almorzo: false,
  ceno: true,
  observacionesAlimenticias: undefined,
  tomoMedicamentos: false,
  observacionesMedicas: undefined,
  temperamento: Temperamento.Balanceado,
  observacionesSocializacion: undefined,
  estadoAnimo: "Tranquilo",
  novedades: undefined,
  fotoNovedades: undefined,
  fotoGeneral: undefined,
  videoNovedades: undefined,
  aplicaDesayuno: true,
  aplicaAlmuerzo: false,
  aplicaCena: true,
  aplicaMedicamentos: false,
};

export type EditModel = {
  id: string;
  desayuno: boolean;
  almorzo: boolean;
  ceno: boolean;
  observacionesAlimenticias?: string;
  observacionesMedicas?: string;
  tomoMedicamentos?: boolean;
  temperamento?: Temperamento;
  observacionesSocializacion?: string;
  estadoAnimo?: EstadoAnimo;
  novedades?: string;
  fotoNovedades?: File;
  fotoNovedadesUrl?: string;
  fotoGeneral?: File;
  fotoGeneralUrl?: string;
  videoNovedades?: File;
  videoNovedadesUrl?: string;
  eliminarFotoNovedades?: Boolean;
  eliminarFotoGeneral?: Boolean;
  eliminarVideoNovedades?: Boolean;
  aplicaDesayuno: boolean;
  aplicaAlmuerzo: boolean;
  aplicaCena: boolean;
  aplicaMedicamentos: boolean;
};

export const generarEditarReporteDiarioModel = (
  reporteDiario: ReporteDiario
): EditModel => {
  return {
    id: reporteDiario.id,
    desayuno: reporteDiario.desayuno === true,
    almorzo: reporteDiario.almorzo === true,
    ceno: reporteDiario.ceno === true,
    aplicaDesayuno: reporteDiario.desayuno !== null,
    aplicaAlmuerzo: reporteDiario.almorzo !== null,
    aplicaCena: reporteDiario.ceno !== null,
    aplicaMedicamentos: reporteDiario.tomoMedicamentos !== null,
    observacionesAlimenticias:
      reporteDiario.observacionesAlimenticias || undefined,
    observacionesMedicas: reporteDiario.observacionesMedicas || undefined,
    tomoMedicamentos: reporteDiario.tomoMedicamentos === true,
    temperamento: reporteDiario.temperamento,
    observacionesSocializacion:
      reporteDiario.observacionesSocializacion || undefined,
    estadoAnimo: reporteDiario.estadoAnimo,
    novedades: reporteDiario.novedades || undefined,
    fotoNovedadesUrl: reporteDiario.fotoNovedades || undefined,
    fotoGeneralUrl: reporteDiario.fotoGeneral || undefined,
    videoNovedadesUrl: reporteDiario.videoNovedades || undefined,
  };
};

export const generarNuevoReporteDiario = async (
  model: Model,
  idAsistencia: string
): Promise<NuevoReporteDiario> => {
  return {
    idAsistencia,
    desayuno: model.aplicaDesayuno ? model.desayuno === true : null,
    ceno: model.aplicaCena ? model.ceno === true : null,
    almorzo: model.aplicaAlmuerzo ? model.almorzo === true : null,
    observacionesAlimenticias: model.observacionesAlimenticias || null,
    tomoMedicamentos: model.aplicaMedicamentos
      ? model.tomoMedicamentos === true
      : null,
    observacionesMedicas: model.observacionesMedicas || null,
    temperamento: model.temperamento,
    observacionesSocializacion: model.observacionesSocializacion || null,
    estadoAnimo: model.estadoAnimo,
    novedades: model.novedades || null,
    fotoNovedades: model.fotoNovedades || null,
    fotoGeneral: model.fotoGeneral || null,
    videoNovedades: model.videoNovedades || null,
  };
};
